import { BaseError } from '@superbet-group/web.lib.utilities';

export default class DepositError extends BaseError {
    constructor(externalErrorCode?: number | string, externalErrorMessage?: number | string) {
        super();
        if (!externalErrorCode) {
            this.message = 'pam.deposit.errors.requirementsError';
        } else if (externalErrorCode === externalErrorMessage && typeof externalErrorCode === 'string') {
            this.message = 'pam.deposit.errors.invalidStatus';
        } else {
            this.message = `pam.deposit.errors.${externalErrorCode}`;
        }
    }
}
